import { createApp, App, provide, computed, ref } from "vue"
import { createPinia } from "pinia"
import { vIntersectionObserver } from '@vueuse/components';

import {
  createRouter,
  createWebHistory,
  useRoute,
  RouteParams,
  RouteLocationNormalizedLoaded,
} from 'vue-router'
import createAppRouter from "@/router"
import i18n from "./i18n"
import { useI18n } from 'vue-i18n'
import Components from "@/components"
import Modules from "@/modules"
import { tableWrapper } from '@/directives/table'
import Plugins from '@/plugins'
import { mask } from 'vue-the-mask'
type CreateApplication = {
  createApp: typeof createApp
  createRouter: typeof createRouter
  createWebHistory: typeof createWebHistory
  createPinia: typeof createPinia
}

const updatedMask = {
  created(el, binding) {
    if (!binding.value) return
    mask(el, binding)
  },
}

export function createApplication({
  createApp,
  createRouter: createRouterInstance,
  createWebHistory,
  createPinia,
}: CreateApplication): App {
  const app = createApp({
    setup() {
      const route: RouteLocationNormalizedLoaded = useRoute()
      const { t: $t } = useI18n()
      const updatedTitle = ref<string | null>(
        null
      )

      const currentTitle = computed(() => {
        if (updatedTitle.value) {
          return updatedTitle.value
        }
        return 'function' === typeof route.meta.title
          ? route.meta.title?.(route.params as RouteParams) ||
              null
          : route.meta.title || null
      })

      provide('currentTitle', currentTitle)
      provide(
        'updateCurrentTitle',
        (title: string | null) => {
          updatedTitle.value = title
        }
      )
      return {}
    },
  })

  app.config.compilerOptions.delimiters = ['[[', ']]']

  const pinia = createPinia()

  const router = createAppRouter({
    app,
    createInstance: createRouterInstance,
    createWebHistory,
    pinia,
  })

  app
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(Components)
    .directive('intersection-observer', vIntersectionObserver)
    .use(Plugins)
    .use(Modules)
    .directive('mask', updatedMask)
    .directive('table-wrapper', tableWrapper)
    .mount('#app')

  return app
}
